<template>
    <b-modal size="md"
             centered
             hide-footer
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal"
             v-on:close="hideModal">
        <template v-slot:modal-title>
            <strong>
                更改服務
            </strong>
        </template>

        <b-form v-on:submit.prevent="submit"
                v-on:reset="reset">
            <b-form-group label-for="service">
                <template v-slot:label>
                    <font-awesome-icon v-bind:icon="['fad', 'store-alt']"></font-awesome-icon> 服務
                </template>
                <v-select id="service"
                          class="bg-light"
                          label="name"
                          v-bind:options="services"
                          v-model="serviceInComponent">
                    <template v-slot:search="{ attributes, events }">
                        <input class="vs__search"
                               v-bind:required="!serviceInComponent"
                               v-bind="attributes"
                               v-on="events">
                    </template>
                    <template v-slot:option="{ name, category, photo }">
                        <div class="d-flex align-items-center">
                            <div class="mr-2">
                                <img class="img-preview"
                                     v-bind:alt="name"
                                     v-bind:src="`${ $config.apiUrl }/${ $config.apiVersion }/service/image/${ photo }`">
                            </div>
                            <div class="flex-grow-1">
                                <strong class="d-inline-block mb-0 text-primary">
                                    <color-dot size="sm"
                                               v-bind:color="category.color">
                                    </color-dot>
                                    <small>{{ category.name }}</small>
                                </strong>
                                <h6 class="font-weight-bolder mb-auto">
                                    {{ name }}
                                </h6>
                            </div>
                        </div>
                    </template>
                    <template v-slot:selected-option="{ name, category, photo }">
                        <div class="d-flex align-items-center">
                            <div class="mr-2">
                                <img class="img-preview"
                                     v-bind:alt="name"
                                     v-bind:src="`${ $config.apiUrl }/${ $config.apiVersion }/service/image/${ photo }`">
                            </div>
                            <div class="flex-grow-1">
                                <strong class="d-inline-block mb-0 text-primary">
                                    <color-dot size="sm"
                                               v-bind:color="category.color">
                                    </color-dot>
                                    <small>{{ category.name }}</small>
                                </strong>
                                <h6 class="font-weight-bolder mb-auto">
                                    {{ name }}
                                </h6>
                            </div>
                        </div>
                    </template>
                </v-select>
            </b-form-group>

            <b-form-group label-for="sku"
                          v-if="serviceInComponent ? serviceInComponent.sku.length > 0 : false">
                <template v-slot:label>
                    <font-awesome-icon v-bind:icon="['fad', 'cubes']"></font-awesome-icon> SKU選擇
                </template>
                <b-form-select id="sku"
                               class="bg-light"
                               required
                               v-model="skuInComponent">
                    <b-form-select-option v-for="{ _id, name } in serviceInComponent.sku"
                                          v-bind:key="_id"
                                          v-bind:value="_id">
                        {{ name }}
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

            <div class="text-center mt-3">
                <button class="btn btn-dark px-4"
                        type="submit"
                        v-bind:class="{ 'btn-loading': isLoading }">
                    更改
                </button>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
import {
    BModal,
    BForm, BFormGroup,
    BFormSelect, BFormSelectOption,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ColorDot from "../ColorDot";

export default {
    name: "ModalChangeService",
    components: {
        ColorDot,
        "v-select": vSelect,
        BModal,
        BForm,
        BFormGroup,
        BFormSelect,
        BFormSelectOption,
    },
    props: {
        "value": {
            type: Boolean,
            default: false,
        },
        "taskId": {
            type: String,
            required: true,
        },
        "serviceSelected": {
            type: Object,
            required: true,
        },
        "skuSelected": {
            type: String,
        },
    },
    data () {
        return {
            isLoading: false,

            service: null,
            sku: null,
        };
    },
    computed: {
        allowSave () {
            return this.name && this.color;
        },
        services () {
            return this.$store.state.data.services;
        },
        serviceInComponent: {
            get () {
                if (this.service) {
                    return this.service;
                }
                return this.serviceSelected;
            },
            set (val) {
                this.service = val;
            },
        },
        skuInComponent: {
            get () {
                if (this.sku) {
                    return this.sku;
                }
                return this.skuSelected;
            },
            set (val) {
                this.sku = val;
            },
        },
    },
    methods: {
        hideModal () {
            this.$emit("input", false);
        },
        reset () {
            this.service = null;
            this.sku = null;
        },
        async submit () {
            this.isLoading = true;
            try {
                await this.$store
                    .dispatch(
                        "tasks/edit",
                        {
                            "_id": this.taskId,
                            "service": this.serviceInComponent,
                            "sku": this.skuInComponent,
                        }
                    );
            } catch (e) {
                console.error(e);
                this.isLoading = false;
                return;
            }
            this.isLoading = false;
            this.hideModal();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
